/** Default meetings URL segment (shared with routing + analytics; keep free of `features/app_shell` to avoid circular imports). */
export const MEETINGS_TAB_BASE_PATH_LEGACY = '/app/meetings'

/** Rebranded meetings URL segment when product refresh app shell is active. */
export const MEETINGS_TAB_BASE_PATH_REBRAND = '/app/calendar'
